export type ProfileDetailsType = {
  tradeName: string | null,
  firstName: string | null,
  lastName: string | null,
  contactName: string | null,
  contactPosition: string | null,
  phoneNumber: string | null,
  phoneExtension: string | null,
  secondaryPhoneNumber: string | null,
  secondaryPhoneExtension: string | null,
  email: string | null,
  fiscalYearEndDate: string | null,
  partialIncomeMonth: string | null,
  ownerOccupiedFlag: boolean | null,
  acknowledgementFlag: boolean | null,
  agentFlag: boolean | null,
  analysisFlag: string | null,
  analysisReviewedBy: string | null,
  analysisReviewedDate: string | null,
  reviewedFlag: boolean | null,
  reviewedBy: string | null,
  reviewedDate: string | null,
  hasApartmentFlag: boolean | null,
  hasCommercialFlag: boolean | null,
  hasAffordableHousingFlag: boolean | null,
  affordableHousingAgreementCodes: string[] | null,
  affordableHousingCount: number | null,
}

export const pickFromProfileDetailsType = <K extends keyof ProfileDetailsType>(data: ProfileDetailsType, keys: readonly K[]): Pick<ProfileDetailsType, K> =>
  keys.reduce(
    (acc, key) => ({ ...acc, [key]: data[key] }),
    {} as Pick<ProfileDetailsType, K>
  );